import {useState,useEffect} from 'react'
import { Button, Dropdown, Menu, Space, message } from "antd"
import { BellOutlined, UserOutlined } from "@ant-design/icons"
import { Logout } from "../../../helpers/auth/logout"
import { useAuth } from "../../../contexts/auth"
import nookies from "nookies"
import PhoneNumberModal from "../../../helpers/auth/phoneNumberModal"
import { recoveryPhone, recoveryPhoneValidCode } from '../../../helpers/auth/login'
import { auth, RecaptchaVerifier } from '../../../helpers/auth/index'

function UserHeader(){
  const { user } = useAuth()
  const [modalVisible, setModalVisible] = useState(false);
  const [codeVisible, setCodeVisible] = useState(false);
  const [dataPhone, setDataPhone] =useState({})
  const [recaptchaVerifier, setRecaptchaVerifier] = useState(null);
  
  
  useEffect(() => {
      auth.useDeviceLanguage();
      
      if (window.recaptchaVerifier) {
        try {
          window.recaptchaVerifier.clear();
        } catch (error) {
          console.error("Error clearing reCAPTCHA:", error);
        }
        window.recaptchaVerifier = null;
      }
  
      
      const recaptchaElement = document.getElementById("recaptcha-container");
      if (recaptchaElement) {
        try {
          const verifier = new RecaptchaVerifier(recaptchaElement, {
            size: "invisible",
            callback: () => {
             
            },
          }, auth);
  
          verifier.render().then((widgetId) => {
            
          }).catch((error) => {
            console.error("Error rendering reCAPTCHA:", error);
          });
  
         
          setRecaptchaVerifier(verifier);
          window.recaptchaVerifier = verifier;
        } catch (error) {
          console.error("Error initializing reCAPTCHA:", error);
        }
      }
  
      
      return () => {
        if (window.recaptchaVerifier) {
          try {
            window.recaptchaVerifier.clear();
          } catch (error) {
            console.error("Error clearing reCAPTCHA on unmount:", error);
          }
          window.recaptchaVerifier = null;
        }
      };
    }, []);

    const onClickMenu = async ({ key }) => {

      if(key === "0"){
        Logout()
      }
  
      if(key === "1") {
        setModalVisible(true)
      }
  }

  const handleModalCancel = () => {
    setModalVisible(false);
  };

  const handleNewPhone = async (phone) => {
    const result = await recoveryPhone(phone, recaptchaVerifier);
  
    if (result.status) {
      setCodeVisible(true);
      setDataPhone({
        verificationId: result.id,
        phone
      });
  
      message.success("Se envió un código al nuevo número de teléfono.");
    } else {
      setModalVisible(false);
    }
  }
  const handleCodeMfa = async (code) => {
    const result = await recoveryPhoneValidCode(
      code,
      dataPhone.verificationId
    );
  
    if (result) {
      setModalVisible(false);
      setCodeVisible(false);
    }
  };

  const menu = (
    <Menu onClick={onClickMenu}>
      <Menu.Item key="1">
        Cambio de Télefono
      </Menu.Item>
      <Menu.Item key="0">
        Cerrar sesión
      </Menu.Item>
    </Menu>
  )

  return (
    <>
    <Space>
      <Button
        id="notifications"
        key="notifications-2"
        type="link"
        shape="circle"
        icon={<BellOutlined />} />
      <span
        key="avatar-3"
        id="user_avatar">
        {user?.claims?.name}
      </span>
      <Dropdown overlay={menu} trigger={["click"]}>
        <Button
          size="large"
          shape="circle"
          icon={<UserOutlined />} />
      </Dropdown>
    </Space>
     <PhoneNumberModal
            visible={modalVisible}
            onCancel={handleModalCancel}
            recovery={true}
            onOk={handleNewPhone}
            recoveryCode={codeVisible}
            onNewPhoneCode={handleCodeMfa}
          />
     <div id="recaptcha-container"></div>
    </>
  )
}

export default UserHeader
